import React, { useRef } from 'react';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import LazyImage from './LazyImage';

const DesktopCategoryRow = ({ categories }) => {
  const navigate = useNavigate();
  const { resolveMediaUrl } = useSettings();
  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const pickCategoryImage = (cat) => {
    const raw = cat?.image || cat?.image_url || cat?.thumbnail || cat?.icon || null;
    return resolveMediaUrl(raw);
  };

  if (!categories || categories.length === 0) return null;

  // Filter valid categories
  const validCategories = categories.filter(c => c && c.id !== 0 && c.slug);

  if (validCategories.length === 0) return null;

  return (
    <div className="mb-16 relative group px-4">
      <div className="flex items-center justify-between mb-8 border-r-4 border-kadolar-600 pr-4">
        <h2 className="text-2xl font-bold text-gray-900">دسته‌بندی‌های محبوب</h2>
        <button 
          onClick={() => navigate('/categories')} 
          className="text-kadolar-600 hover:text-kadolar-700 font-medium flex items-center gap-1 transition-colors text-sm"
        >
          مشاهده همه
          <ChevronLeftIcon className="w-4 h-4" />
        </button>
      </div>
      
      <div className="relative">
        <button 
            onClick={scrollRight}
            className="absolute -right-5 top-1/2 -translate-y-1/2 z-20 bg-white border border-gray-100 text-gray-600 p-3 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-kadolar-50 hover:text-kadolar-600"
            aria-label="Scroll Right"
        >
            <ChevronRightIcon className="w-6 h-6" />
        </button>
        <button 
            onClick={scrollLeft}
            className="absolute -left-5 top-1/2 -translate-y-1/2 z-20 bg-white border border-gray-100 text-gray-600 p-3 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-kadolar-50 hover:text-kadolar-600"
            aria-label="Scroll Left"
        >
            <ChevronLeftIcon className="w-6 h-6" />
        </button>

        <div 
            ref={scrollContainerRef}
            className="flex gap-8 overflow-x-auto pb-8 pt-4 px-4 scrollbar-hide snap-x snap-mandatory"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
            {validCategories.map((cat) => (
                <div 
                    key={cat.id} 
                    className="flex flex-col items-center gap-4 cursor-pointer group/cat min-w-[120px] snap-start"
                    onClick={() => navigate(`/category/${cat.slug}`)}
                >
                    <div className="w-28 h-28 rounded-full bg-white border-2 border-gray-100 p-1 shadow-md group-hover/cat:shadow-xl group-hover/cat:border-kadolar-200 transition-all duration-300 overflow-hidden relative">
                        <div className="w-full h-full rounded-full overflow-hidden bg-gray-50">
                    <LazyImage 
                        src={pickCategoryImage(cat)} 
                        alt={cat.name} 
                        className="w-full h-full object-cover group-hover/cat:scale-110 transition-transform duration-500"
                    />
                </div>
            </div>
            <span className="text-gray-700 font-medium text-center group-hover/cat:text-kadolar-700 transition-colors">
                        {cat.name}
                    </span>
                </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default DesktopCategoryRow;
